__turbopack_context__.v({
  "chip": "McG8CW_chip",
  "count": "McG8CW_count",
  "lg": "McG8CW_lg",
  "md": "McG8CW_md",
  "minimal": "McG8CW_minimal",
  "pill": "McG8CW_pill",
  "rectangle": "McG8CW_rectangle",
  "sm": "McG8CW_sm",
  "underline": "McG8CW_underline",
});
